import React from "react";
import "../../Button/Button.css";
import { Link } from "react-router-dom";

const Index = ({ buttonText, _class, pageLink, OutlineDropdown, _linkClass, textClass, showAll }) => {
  return (
    <>
      {pageLink ? (
         <Link to={pageLink} className={`outline-button ${_linkClass}`} data-aos="fade-up" data-aos-offset="100" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine">
         <button className={`webButton learn-more ${_class}`}>
         <span className="circle" aria-hidden="true">
           <span className="icon arrow"></span>
         </span>
         <span className={`button-text ${textClass}`}>{buttonText}</span>
       </button>
       </Link>
      ):(
        <button className={`webButton learn-more ${_class}`} data-aos="fade-up" data-aos-offset="100" data-aos-duration="500" data-aos-once="true" data-aos-easing="ease-in-sine" onClick={showAll}>
        <span className="circle" aria-hidden="true">
          <span className="icon arrow"></span>
        </span>
        <span className={`button-text ${textClass}`}>{buttonText}</span>
      </button>
      )}
    </>
  );
};

export default Index;
